import React from 'react';
import styled from 'styled-components';

type TableComponentProps = {
  contents: Array<object>
}

const TableGroupStyle = styled.div`
  overflow-x: auto;
`;

const TableStyle = styled.table`
  background-color: #f2f0e9;
  border-spacing: 0;
  border-radius: 4px;
  padding: 0 20px;
  min-width: 60%;

  tbody {
    tr {
      th {
        border-bottom: 1px solid #dbdbdb;
        font-size: 14px;
        font-weight: bold;
        text-align: left;
        white-space: nowrap;
        padding: 20px 10px;
      }

      td {
        border-bottom: 1px solid #dbdbdb;
        font-size: 14px;
        white-space: nowrap;
        padding: 20px 10px;

        a {
          color: #0000ee;
          text-decoration: none;

          &:hover {
            color: #0000ee;
            text-decoration: underline;
          }
        }
      }
    }

    tr:last-child {
      th {
        border-bottom: none;
      }
      td {
        border-bottom: none;
      }
    }

    @media (max-width: 768px) {
      tr {
        th, td {
          display: block;
          text-align: left;
          padding-left: 0;
        }

        th {
          padding-bottom: 5px;
          border-bottom: none;
        }

        td {
          padding: 5px 0;
        }
      }

      tr:last-child {
        td {
          padding-bottom: 20px;
        }
      }
    }

    -webkit-text-size-adjust: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Table: React.FC<TableComponentProps> = ({ contents }) => {
  return (
    <TableGroupStyle>
      <TableStyle>
        <tbody>
          { contents.map((content, index) => {
            return (
              <tr key={index}>
                <th>{ content['head'] }</th>
                <td>{ content['data'] }</td>
              </tr>
            );
          })}
        </tbody>
      </TableStyle>
    </TableGroupStyle>
  );
};

export default Table;
